var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrows",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.467,239.933l-170.667-128c-14.064-10.548-34.133-0.513-34.133,17.067v64h-85.333 C201.551,193,192,202.551,192,214.333v85.333c0,11.782,9.551,21.333,21.333,21.333h85.333v64c0,17.58,20.07,27.614,34.133,17.067 l170.667-128C514.844,265.533,514.844,248.467,503.467,239.933z M341.333,342.333v-42.667c0-11.782-9.551-21.333-21.333-21.333 h-85.333v-42.667H320c11.782,0,21.333-9.551,21.333-21.333v-42.667L455.111,257L341.333,342.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.333,193C137.551,193,128,202.551,128,214.333v85.333c0,11.782,9.551,21.333,21.333,21.333 c11.782,0,21.333-9.551,21.333-21.333v-85.333C170.667,202.551,161.115,193,149.333,193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.333,193C73.551,193,64,202.551,64,214.333v85.333C64,311.449,73.551,321,85.333,321 c11.782,0,21.333-9.551,21.333-21.333v-85.333C106.667,202.551,97.115,193,85.333,193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.333,193C9.551,193,0,202.551,0,214.333v85.333C0,311.449,9.551,321,21.333,321c11.782,0,21.333-9.551,21.333-21.333 v-85.333C42.667,202.551,33.115,193,21.333,193z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.80a6df927c4281670a8ee570739b0902.svg";
export { ForwardRef as ReactComponent };